import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_GLOBAL_SHARE_BUTTON_CONFIG = defineFcm('global_share_button_config')
	.asJson(
		createShapeNormalizer({
			type: 'array',
			shape: {
				type: 'enum',
				values: [
					'copy',
					'facebook',
					'instagram',
					'whatsapp',
					'twitter',
					'email',
					'facebookMessenger',
					'sms',
					'line',
					'reddit',
					'nextdoor',
					'vk',
					'mobileNativeShare',
				] as const,
			},
		}),
	)
	.withDefault(['copy', 'facebook', 'instagram', 'whatsapp', 'twitter', 'email', 'facebookMessenger', 'sms'])
	.toConfig({
		owner: 'squad-starfish',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Global config for share buttons',
		description: 'Change the order and filter share buttons globally',
		template: [
			'copy',
			'facebook',
			'instagram',
			'whatsapp',
			'twitter',
			'email',
			'facebookMessenger',
			'sms',
			'line',
			'reddit',
			'nextdoor',
			'vk',
			'mobileNativeShare',
		],
	});
